/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const NOMATIM_SERVICE = { getAddress};

/* Services */
//Service to create rankings
function getAddress(latitude, longitude)
{
    // Build API call.
    var url = `${process.env.VUE_APP_NOMATIM}?lat=${latitude}&lon=${longitude}&format=json`;

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}
